module.exports = __webpack_public_path__ + "static/media/6_evenement.d2b89bc9.jpg";